<template>
  <RadioGroup
    :disabled="disabled"
    :value="modelValue"
    @change="(e) => $emit('update:modelValue', e.target.value)"
    :optionType="optionType"
    :buttonStyle="buttonStyle"
    :size="size"
  >
    <Radio
      v-for="(option, index) in options"
      :key="index"
      :value="option.value"
    >
      {{ option?.label }}
    </Radio>
  </RadioGroup>
</template>

<script>
import { RadioGroup, Radio } from 'ant-design-vue';
import BaseIcon from '@/rex-components/BaseIcon.vue';

export default {
  emits: ['update:modelValue'],
  components: {
    RadioGroup,
    Radio,
    BaseIcon,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionType: {
      type: String,
      default: 'default',
    },
    buttonStyle: {
      type: String,
      default: 'outline',
    },
    size: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
/* CSS to change the color of radio buttons */
:deep(.ant-radio-inner:after) {
  background-color: $slider-before-color;
  scale: 1.5;
}
:deep(.ant-radio-checked .ant-radio-inner) {
  background-color: $calendar-disabled-bg;
  border-width: 0.16rem;
}

.iconSize {
  margin-right: 0.5rem;
}
</style>
